import React, {Component} from 'react';
import Request from '../../assets/js/request.js';
import './index.css';
export default class Qry extends Component{
	constructor(props) {
		super(props);
		this.state = {
			codeImg: '',
			nonce: '',
			postNo: '',
			mobileNo: '',
			code: '',
			pkgInfo: [],//查询到的包裹信息
			validate: {},//验证信息
			requestDesc: '',//请求的错误信息
		}
	}
    
	componentDidMount() {
		// this.refreshCode();
		this.initValidate();
	}
	checkReClick(nonce = 0) {//判断是否重复点击
		let cliTime = localStorage.cliTime;
		cliTime = cliTime ? cliTime : 0;
		let reClickFlag = Math.abs(cliTime - nonce) < 1000;
		if(!reClickFlag) {
			localStorage.cliTime = nonce;
		}
		return  reClickFlag;
	}
	refreshCode(flag = true) {//获取验证码,flag是否是用户点击
		let nonce = new Date().getTime();
		if(flag && this.checkReClick(nonce)) {
			return;
		}
		this.setState({
			nonce: nonce
		});
		let _this = this;
		Request({
			url: 'pkg/captcha',
			params: {nonce: nonce},
			success(res) {
				// console.log("captcha:", res);
				if(res.code === 200) {
					_this.setState({
						codeImg: `data:image/png;base64,${res.desc}`
					});
				}
			},
			fail(res) {
				// console.log("验证码失败:", res);
			}
		});
	}
	qryPkg() {//请求包裹信息
		let _this = this;
		let nonce = new Date().getTime();
		if(this.checkReClick(nonce)) {
			return;
		}
		this.setState({
			requestDesc: ''
		});
		if(!this.validateInput()){
			return;
		}
		let params = {
			postNo: this.state.postNo,
			mobileNo: this.state.mobileNo,
			code: this.state.code,
			nonce: this.state.nonce
		};
		Request({
			url: 'pkg',
			params: params,
			success(res) {
				// console.log("qryPkg:", res);
				if(res.code === 200) {
					let pkgInfo = res.data.datas ? res.data.datas : [];
					_this.setState({
						pkgInfo: pkgInfo,
						requestDesc: ''
					});
					if(!pkgInfo.length) {
						alert('暂无包裹!');
					}
				} else {
					// alert(res.desc);
					_this.setState({
						pkgInfo: [],
						requestDesc: res.desc
					});
				}
				_this.refreshCode(false);
			},
			fail() {
				_this.refreshCode(false);
			}
		});
	}
	setInputValue(e, inputName){//input输入
		let value = e.target.value.trim();
		value = value.replace(/\D/g, '');
		this.setState({
			[inputName]: value
		});
		//手机号验证正确且未获取验证码，则获取
		if(inputName === 'mobileNo' && (/^1[34578]\d{9}$/).test(value) && this.state.codeImg === ''){
			this.refreshCode();
		}
	}
	renderPkgInfo() { //渲染包裹信息
		return (
			<div className="result_wrapper">
				<div id="result" className="clearfix">
					<span className="result_title">包裹信息</span>
					<table>
						<thead>
							<tr>
								<th>运单号</th>
								<th>收件人手机号</th>
								<th>投递员手机号</th>
								<th>投递时间</th>
								<th>提取时间</th>
								<th>状态</th>
							</tr>
						</thead>
						<tbody id="tbody">
							{
								this.state.pkgInfo.map((item, idx) => {
									return (
										<tr key={idx}>
											<td>{item.postNo}</td>
											<td>{item.rcvMobile}</td>
											<td>{item.courierMobile}</td>
											<td>{item.pushTs}</td>
											<td>{item.popTs}</td>
											<td>{item.pkgState}</td>
										</tr>
									)
								})
							}
						</tbody>
					</table>
				</div>
			</div>
		)
	}
	validateInput() {//判断用户输入
		let validateFlag = true;
		let validate = {};
		let mobile = this.state.mobileNo,
				postNo = this.state.postNo,
				code = this.state.code;
		if(!mobile) {
			validate.mobileNo = {
				type: 2,
				msg: '请输入手机号!'
			};
			validateFlag = false;
		} else if(!(/^1[34578]\d{9}$/.test(mobile))) {
			validate.mobileNo = {
				type: 2,
				msg: '请输入正确的手机号!'
			};
			validateFlag = false;
		} else {
			validate.mobileNo = {
				type: 1,
				msg: ''
			}
		}
		if(!postNo) {
			validate.postNo = {
				type: 2,
				msg: '请输入运单号'
			};
			validateFlag = false;
		} else {
			validate.postNo = {
				type: 1,
				msg: ''
			}
		}
		if(!code) {
			validate.code = {
				type: 2,
				msg: '请输入验证码!'
			};
			validateFlag = false;
		} else {
			validate.code = {
				type: 1,
				msg: ''
			}
		}
		// console.log("validate:", validate);
		this.setState({
			validate: validate
		});
		return validateFlag;
	}
	initValidate() {//初始化验证信息
		let validate = { //type 0，1成功，2失败
			postNo: { 
				type: 0,
				msg: ''
			}, 
			mobileNo: {
				type: 0,
				msg: ''
			}, 
			code: {
				type: 0,
				msg: ''
			}
		}
		this.setState({
			validate: validate
		});
	}
	renderMsg(varObj) {//渲染各个输入框的检测结果
		if(varObj === undefined) {
			return;
		}
		return varObj.type !== 0
			? 
			(
				<span className={`msg ${varObj.type === 2 ? 'err z-dragIn' : ''}`}>
					<i></i><font>{varObj.msg}</font>
				</span>
			)
			: ''
	}
	renderRequestErrMsg() { //请求失败，渲染错误信息
		return this.state.requestDesc ?
				<p className="qry_result_err z-dragIn">{this.state.requestDesc}</p>
			: ''
	}

	render() {
		return (
			<div className="content qry">
				<form className="clearfix" id="qryForm" action="" method="post">
					<div className="qry_input_wrapper">
						<label>手机号：</label>
						<div className="input">
							<input type="text"
								onChange={(e)=>this.setInputValue(e, 'mobileNo')} 
								value={this.state.mobileNo}/>
						</div>
						{
							this.renderMsg(this.state.validate.mobileNo)
						}
					</div>
					<div className="qry_input_wrapper">
						<label>运单号：</label>
						<div className="input">
							<input type="text" value={this.state.postNo}
								onChange={(e) => this.setInputValue(e, 'postNo')} />
						</div>
						{
							this.renderMsg(this.state.validate.postNo)
						}
					</div>
					<div className="qry_input_wrapper">
						<label>验证码：</label>
						<div className="input">
							<input type="text" value={this.state.code} id="verifyCode"
								onChange = {(e) => this.setInputValue(e, 'code')} />
							{ 
								this.state.codeImg ? 
									<img alt="" id="checkcodeImg" 
										src={this.state.codeImg} 
										onClick={() => this.refreshCode()} 
									/>
								:
									<span className="pointer" onClick={() => this.refreshCode()} >获取验证码</span>
							}
						</div>
						{
							this.renderMsg(this.state.validate.code)
						}
					</div>
					<div className="qry_search">
						{
							this.renderRequestErrMsg()
						}
						<button type="button" id="qryBtn" onClick={() => this.qryPkg()}>查 询</button>
						<a href="http://m.kuaidi100.com" target="_blank" rel='noreferrer noopener'>快递查询</a>
					</div>
					<div className="qry_tip">
						注：仅供查询30天内投递记录
					</div>
				</form>
				{
					this.state.pkgInfo.length ? this.renderPkgInfo() : ''
				}
			</div>
		)
	}
}